import MWBIcons from './components/MWBIcons';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import Components from 'components';
import Plugins from 'plugins';
import CustomFormFields from './components/CustomFormFields';
import IntlyVideo from 'components/intly-video';
import CustomVideoPlayer from './components/CustomVideoPlayer';
// Initialise Alpine
window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.start();

// Initialize Video
document.querySelectorAll(".intly-video").forEach((root) => { new IntlyVideo(root); });

// block specific scripts (see /blocks/block.example.js)
// e.g. import "blocks/hero/hero001"

jQuery(function($) {
    Components.init();
    Plugins.init();

    $('form.venue-search #locate').click(function() {
        $(this).css('pointer-events', 'none');
        $(this).find('#locate-ready').hide();
        $(this).find('#locate-loading').show();
        let form = $('form.venue-search');

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(position) {
                form.find('#search-input').val('Current location');
                form.find('#location-lat').val(position.coords.latitude);
                form.find('#location-lng').val(position.coords.longitude);
                form.submit();
                form.find('#locate').css('pointer-events', 'auto');
                form.find('#locate').find('#locate-loading').hide();
                form.find('#locate').find('#locate-ready').show();
            });
        } else {
            console.log("Geolocation is not supported by this browser.");
            form.find('#locate').css('pointer-events', 'auto');
            form.find('#locate').find('#locate-loading').hide();
            form.find('#locate').find('#locate-ready').show();
        }
    });

    $('form.venue-search #reset').click(function() {
        let form = $('form.venue-search');
        form.find('#search-input').val('');
        form.find('#location-lat').val('');
        form.find('#location-lng').val('');
        form.find('#distance').val('50');
        form.submit();
    });

    $('form.venue-search #search-input').on('input', function() {
        let form = $('form.venue-search');
        form.find('#location-lat').val('');
        form.find('#location-lng').val('');
    });

    $('select#input_3_18').on('change', function() {
        let dropdown1 = $('select#input_3_19');
        let dropdown2 = $('select#input_3_20');

        let selected = $(this).val();

        if(selected == '') {
            dropdown1.html('<option value="" selected="selected" class="gf_placeholder">Select an area first...</option>');
            dropdown2.html('<option value="" selected="selected" class="gf_placeholder">Select an area first...</option>');
            return;
        }

        dropdown1.html('<option value="">Loading...</option>');
        dropdown2.html('<option value="">Loading...</option>');

        $.ajax({
            type: 'POST',
            url: scriptVars.ajaxUrl,
            dataType: 'json',
            data: {
                action: 'get_venue_dropdown_options',
                franchise: selected
            },
            success: function(data) {
                if($.isEmptyObject(data)) {
                    dropdown1.html('<option value="" selected="selected">No options available</option>');
                    dropdown2.html('<option value="" selected="selected">No options available</option>');
                } else {
                    dropdown1.html('<option value="" selected="selected" class="gf_placeholder">Select an option...</option>');
                    dropdown2.html('<option value="" selected="selected" class="gf_placeholder">Select an option...</option>');

                    $.each(data, function(key, value) {
                        dropdown1.append('<option value="' + key + '">' + value + '</option>');
                        dropdown2.append('<option value="' + key + '">' + value + '</option>');
                    });
                }
            },
            error: function(error) {
                dropdown1.html('<option value="" selected="selected">No options available</option>');
                dropdown2.html('<option value="" selected="selected">No options available</option>');
            }
        });
    }).change();
});
